<div
    #cardContainer
    [id]="id"
    class="agpr-postFeed agpr-contextMenu-parent"
    [attr.data-mention-id]="mention.mentionId"
    [attr.data-mercury-id]="mention.id"
    (agprClickUnless)="openPostViewer()"
    [agprClickUnlessSelectors]="['agpr-checkbox', 'a']"
    [@showMoreContent]="{value: expanded ? 'expanded' : 'collapsed', params: {collapsedHeight}}"
    (@showMoreContent.done)="contentVisible = expanded"
>
    <div
        class="agpr-postFeed-index"
        *ngIf="index"
    >
        {{ index }}
    </div>
    <div
        class="agpr-postFeed-main"
        [ngClass]="{'agpr-postFeed-main--selected': !!selectedResults?.includes(mention)}"
    >
        <div class="agpr-postFeed-checkbox">
            <agpr-checkbox
                *ngIf="showCheckbox"
                [id]="id + '_postFeedCheckbox'"
                [value]="mention"
                [disabled]="allSelected"
                [hiddenLabel]="
                    mention?.username ? mention.username
                    : (mention?.author?.name ? mention.author.name
                    : (mention?.subreddit ? mention.subreddit
                    :  mention?.tweetData?.originalTweetData?.originalUserName))
                "
                (click)="$event?.stopPropagation()"
                [(ngModel)]="selectedResults"
                (ngModelChange)="postSelectionChanged()"
            ></agpr-checkbox>
        </div>
        <div
            [id]="id + '_feedContent'"
            class="agpr-postFeed-mainInfo"
        >
            @if (tweetType === tweetTypeEnum.RETWEET || linkedinType === linkedinTypeEnum.REPOST) {
                <div class="agpr-postFeed-mainInfo-retweet">
                    <span class="agpr-postFeed-mainInfo-retweetIcon fa-regular fa-duotone fa-arrows-retweet"></span>
                    <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
                    <div
                        class="agpr-postFeed-mainInfo-retweetHandle"
                        (click)="$event?.stopPropagation()"
                    >
                        <div
                            class="agpr-postFeed-link"
                            [innerHTML]="mention?.handle | mentionLinks:mention.mediaType.id"
                        ></div>
                        @if (!mention?.handle) {
                            <div class="agpr-postFeed-link">
                                {{ 'Social.postFeed.twitterUserUnavailable' | localize }}
                            </div>
                        }
                    </div>
                    <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
                    <span>{{ 'Mention.Reposted' | localize }}</span>
                </div>
            }

            <div class="agpr-postFeed-mainInfo-topRow">
                <div class="agpr-postFeed-mainInfo-avatar">
                    <!-- For retweet scenario, here we use placeholder for now, as b.e has difficulty in getting original tweet avatar -->
                    <a
                        *ngIf="tweetType !== tweetTypeEnum.RETWEET && mention?.socialAvatarUrl"
                        [attr.aria-label]="'Social.postFeed.profileImage' | localize"
                        class="agpr-postFeed-mainInfo-avatar-img"
                        target="_blank"
                        [href]="mention.socialUrl"
                    >
                        <img
                            [agprImageSrc]="mention?.socialAvatarUrl | twitterAvatarSize:twitterAvatarSizes.bigger"
                            alt=""
                            [agprDefaultImage]="imageDefault[mediaType]"
                            (agprFailedToFetchImage)="mention.socialAvatarUrl = null;"
                        />
                    </a>

                    <a
                        *ngIf="!mention.socialAvatarUrl || tweetType === tweetTypeEnum.RETWEET"
                        class="agpr-postFeed-mainInfo-avatarPlaceholder"
                        [style.background-color]="socialNetworkTypeColorMap[mention?.mediaType.id]"
                        [attr.aria-label]="'Social.postFeed.profileImage' | localize"
                        target="_blank"
                        [href]="mention.socialUrl"
                    >
                        <span>{{ mention?.avatarPlaceholderText }}</span>
                    </a>
                </div>
                <div class="agpr-postFeed-mainInfo-titleContainer">
                    <div class="agpr-postFeed-mainInfo-authorContainer">
                        @if ((mention?.showTranslated && mention?.translation) ||
                                mention?.translation?.failedToTranslate
                        ) {
                            <div class="agpr-mention-showTranslated">
                                <agpr-mention-language-display
                                    [mention]="mention"
                                    [showLanguageLabel]="true"
                                ></agpr-mention-language-display>
                            </div>
                        }

                        <div class="agpr-postFeed-mainInfo-authorName">
                            @if (tweetType !== tweetTypeEnum.RETWEET && !mention?.username) {
                                {{ 'Social.postFeed.twitterUserUnavailable' | localize }}
                            }

                            @if (
                                tweetType !== tweetTypeEnum.RETWEET &&
                                !mention?.subreddit &&
                                mediaType !== mediaTypes.YOUTUBE &&
                                linkedinType !== linkedinTypeEnum.REPOST
                            ) {
                                {{ mention?.username ? mention?.username : mention?.author?.name }}
                            }

                            @if (mediaType === mediaTypes.YOUTUBE) {
                                <a
                                    *ngIf="mention?.socialUrl"
                                    [href]="mention?.socialUrl"
                                    target="_blank"
                                    (click)="$event?.stopPropagation()"
                                >
                                    {{ mention?.username ? mention?.username : mention?.author?.name}}
                                </a>
                                <span *ngIf="!mention?.socialUrl">
                                    {{ mention?.username ? mention?.username : mention?.author?.name}}
                                </span>
                            }

                            @if (tweetType === tweetTypeEnum.RETWEET) {
                                {{ mention?.tweetData?.originalTweetData?.originalUserName }}
                            }

                            @if (linkedinType === linkedinTypeEnum.REPOST) {
                                {{ mention?.linkedinData?.originalActivityData?.originalUserName }}
                            }

                            @if (mention?.subreddit) {
                                <a
                                    [href]="mention?.socialUrl"
                                    target="_blank"
                                    (click)="$event?.stopPropagation()"
                                >
                                    {{ mention?.subreddit }}
                                </a>
                            }
                        </div>
                        <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
                        <div
                            class="agpr-postFeed-mainInfo-handle"
                            (click)="$event?.stopPropagation()"
                        >
                            @if (tweetType !== tweetTypeEnum.RETWEET && !mention?.handle) {
                                <div>
                                    {{ 'Social.postFeed.twitterUserUnavailable' | localize }}
                                </div>
                            }

                            @if (tweetType === tweetTypeEnum.RETWEET) {
                                <div
                                    class="agpr-postFeed-link"
                                    [innerHTML]="'@' + mention?.tweetData?.originalTweetData?.originalUserHandle | mentionLinks:mention.mediaType.id"
                                ></div>
                            } @else if (linkedinType === linkedinTypeEnum.REPOST) {
                                <div
                                    class="agpr-postFeed-link"
                                    [innerHTML]="mention?.linkedinData?.originalActivityData?.originalUserHandle | mentionLinks:mention.mediaType.id"
                                ></div>
                            } @else if (mediaType === mediaTypes.YOUTUBE) {
                                <div
                                    class="agpr-postFeed-link"
                                    [innerHTML]="mention.youtubeHandle | mentionLinks:mention.mediaType.id"
                                ></div>
                            } @else {
                                <div
                                    class="agpr-postFeed-link"
                                    [innerHTML]="mention?.handle | mentionLinks:mention.mediaType.id"
                                ></div>
                            }
                        </div>
                        <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
                    </div>
                    <div
                        *ngIf="mention?.musicTitle"
                        class="agpr-postFeed-mainInfo-musicContainer"
                    >
                        <span class="fa-solid fa-music agpr-postFeed-mainInfo-musicContainer-icon"></span>
                        <a
                            class="agpr-postFeed-mainInfo-musicContainer-link"
                            [href]="mention?.musicUrl"
                            target="_blank"
                            (click)="$event?.stopPropagation()"
                        >
                            {{ mention?.musicTitle }}
                        </a>
                    </div>
                </div>
                <div class="agpr-postFeed-mainInfo-iconAndTime">
                    <img
                        *ngIf="mention?.mediaType?.socialIconImageUrl"
                        [src]="appBaseHref + mention.mediaType.socialIconImageUrl"
                        [alt]="('MediaType.' + mediaType) | localize"
                        tooltipPosition='top'
                        [agprTooltip]="('MediaType.' + mediaType) | localize"
                    />
                </div>
            </div>
            <div
                #mainBody
                class="agpr-postFeed-mainInfo-body"
                [ngClass]="{ 'agpr-postFeed-mainInfo-body-unexpanded': !contentVisible }"
            >

                @if (tweetType === tweetTypeEnum.REPLY && mention?.tweetData?.originalTweetData?.originalUserHandle) {
                    <span
                        class="agpr-postFeed-mainInfo-body-replyLine"
                        [innerHTML]="(('Social.postFeed.replyingTo' | localize) + '@' + mention?.tweetData?.originalTweetData?.originalUserHandle) | mentionLinks:mention.mediaType.id"
                    >
                    </span>
                } @else if (tweetType === tweetTypeEnum.REPLY && mention?.tweetData?.originalTweetData?.originalUserName) {
                    <span
                        class="agpr-postFeed-mainInfo-body-replyLine"
                        [innerHTML]="(('Social.postFeed.replyingTo' | localize) + '@' + mention?.tweetData?.originalTweetData?.originalUserName) | mentionLinks:mention.mediaType.id"
                    >
                    </span>
                }

                <ng-container
                    [ngTemplateOutlet]="mention?.showTranslated || (mention?.isTranslatedPreferred && mention?.translation) ? isTranslation : isNotTranslation"
                ></ng-container>
                <ng-template #isTranslation>
                    <div *ngIf="highlightKeywords">
                        <span
                            [ngClass]="{'agpr-postFeed-mainInfo-body-headline': mention.body}"
                            [innerHTML]="mention.translation?.headline | highlightKeywords: highlightKeywords"
                        >
                        </span>
                        <span
                            [innerHTML]="mention.translation?.body | mentionLinks:mention.mediaType.id | highlightKeywords: highlightKeywords"

                        ></span>
                    </div>
                    <div *ngIf="!highlightKeywords">
                        <span
                            [ngClass]="{'agpr-postFeed-mainInfo-body-headline': mention.translation?.body}"
                        >
                            {{mention.translation?.headline}}
                        </span>
                        <span>{{mention.translation?.body}}</span>
                    </div>

                    <agpr-original-tweet
                        [tweetData]="mention.tweetData"
                    ></agpr-original-tweet>
                </ng-template>
                <ng-template #isNotTranslation>
                    <div *ngIf="highlightKeywords">
                        <span
                            [ngClass]="{'agpr-postFeed-mainInfo-body-headline': mention.body}"
                            [innerHTML]="mention.headline | highlightKeywords: highlightKeywords"
                        >
                        </span>
                        <span
                            [innerHTML]="mention.body | mentionLinks:mention.mediaType.id | highlightKeywords: highlightKeywords"

                        ></span>
                    </div>
                    <div *ngIf="!highlightKeywords">
                        <span
                            [ngClass]="{'agpr-postFeed-mainInfo-body-headline': mention.body}"
                        >
                            {{mention.headline}}
                        </span>
                        <span>{{mention.body}}</span>
                    </div>

                    @if (contentVisible) {
                        <agpr-original-tweet
                            [tweetData]="mention.tweetData"
                        ></agpr-original-tweet>
                    }
                </ng-template>

            </div>
            <div
                class="agpr-postFeed-mainInfo-images"
                [ngClass]="{'agpr-postFeed-mainInfo-images--hidden': !_showImages && !contentVisible}"
            >
                <div
                    *ngFor="let image of mention.images;"
                    class="agpr-postFeed-mainInfo-mediaWrapper"
                >
                    @if(!image.error) {
                         <img
                            class="agpr-postFeed-mainInfo-media"
                            [src]="image.source"
                            [alt]="'Social.postFeed.mentionImage.alt' | localize"
                            (error)="image.error = true"
                        />
                    } @else {
                        <div class="agpr-postFeed-mainInfo-mediaWrapper-imageFailedMessage">
                            <span class="agpr-postFeed-mainInfo-mediaWrapper-imageFailedIcon fa-regular fa-duotone fa-ban fa-3x"></span>
                            {{ 'Social.postFeed.mentionImage.error' | localize }}
                        </div>
                    }
                </div>
                <div
                    *ngIf="embedVideoUrl"
                    class="agpr-postFeed-mainInfo-mediaWrapper"
                >
                    <iframe
                        [src]="embedVideoUrl | agprBypassURLSecurity"
                        class="agpr-postFeed-mainInfo-media"
                        width="100%"
                        height="420"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                        [title]="iframeTitle"
                    >
                    </iframe>
                </div>
            </div>

            @if (
                mediaType === mediaTypes.TWITTER ||
                mediaType === mediaTypes.LINKEDIN ||
                mediaType === mediaTypes.BLUESKY
            ) {
                <div class="agpr-postFeed-mainInfo-engagement">
                    @if (mediaType === mediaTypes.TWITTER || mediaType === mediaTypes.BLUESKY) {
                        <div
                            class="agpr-postFeed-mainInfo-engagementWrapper"
                            [agprTooltip]="('Social.postFeed.likes' | localize) + (mention?.like ?? 'N/A') + '\n' + ('Social.postFeed.lastUpdate' | localize)
                                + (mention?.engagementLastFetchedDate ? (mention?.engagementLastFetchedDate | changeTimeZone: preferences.timeZone: 'MMMM D, YYYY H:mm z') : 'N/A')"
                            tooltipPosition='top'
                        >
                            <span class="agpr-postFeed-mainInfo-engagement-icon fa-regular fa-duotone fa-heart"></span>
                            <span>{{ mention?.like ?? 'N/A' }}</span>
                        </div>

                        <div
                            class="agpr-postFeed-mainInfo-engagementWrapper"
                            [agprTooltip]="('Social.postFeed.Replies' | localize) + (mention?.reply ?? 'N/A') + '\n' + ('Social.postFeed.lastUpdate' | localize)
                                + (mention?.engagementLastFetchedDate ? (mention?.engagementLastFetchedDate | changeTimeZone: preferences.timeZone: 'MMMM D, YYYY H:mm z') : 'N/A')"
                            tooltipPosition='top'
                        >
                            <span class="agpr-postFeed-mainInfo-engagement-icon fa-regular fa-duotone fa-comment"></span>
                            <span>{{ mention?.reply ?? 'N/A' }}</span>
                        </div>

                        <div
                            class="agpr-postFeed-mainInfo-engagementWrapper"
                            [agprTooltip]="('Social.postFeed.retweets' | localize) + (mention?.share ?? 'N/A') + '\n' + ('Social.postFeed.lastUpdate' | localize)
                                + (mention?.engagementLastFetchedDate ? (mention?.engagementLastFetchedDate | changeTimeZone: preferences.timeZone: 'MMMM D, YYYY H:mm z') : 'N/A')"
                            tooltipPosition='top'
                        >
                            <span class="agpr-postFeed-mainInfo-engagement-icon fa-regular fa-duotone fa-arrows-retweet"></span>
                            <span>{{ mention?.share ?? 'N/A' }}</span>
                        </div>
                    } @else if (mediaType === mediaTypes.LINKEDIN) {
                        <div
                            class="agpr-postFeed-mainInfo-engagementWrapper"
                            [agprTooltip]="('Social.postFeed.reactions' | localize) + (mention?.like ?? 'N/A') + '\n' + ('Social.postFeed.lastUpdate' | localize)
                                + (mention?.engagementLastFetchedDate ? (mention?.engagementLastFetchedDate | changeTimeZone: preferences.timeZone: 'MMMM D, YYYY H:mm z') : 'N/A')"
                            tooltipPosition='top'
                        >
                            <span class="agpr-postFeed-mainInfo-engagement-icon fa-regular fa-duotone fa-heart"></span>
                            <span>{{ mention?.like ?? 'N/A' }}</span>
                        </div>

                        <div
                            class="agpr-postFeed-mainInfo-engagementWrapper"
                            [agprTooltip]="('Social.postFeed.Replies' | localize) + (mention?.reply ?? 'N/A') + '\n' + ('Social.postFeed.lastUpdate' | localize)
                                + (mention?.engagementLastFetchedDate ? (mention?.engagementLastFetchedDate | changeTimeZone: preferences.timeZone: 'MMMM D, YYYY H:mm z') : 'N/A')"
                            tooltipPosition='top'
                        >
                            <span class="agpr-postFeed-mainInfo-engagement-icon fa-regular fa-duotone fa-comment"></span>
                            <span>{{ mention?.reply ?? 'N/A' }}</span>
                        </div>
                    }
                </div>
            }

            @if (
                mediaType === mediaTypes.FACEBOOK ||
                mediaType === mediaTypes.INSTAGRAM ||
                mediaType === mediaTypes.YOUTUBE ||
                mediaType === mediaTypes.TIKTOK
            ) {
                <div class="agpr-postFeed-mainInfo-engagement">
                    @if (mediaType === mediaTypes.YOUTUBE || mediaType === mediaTypes.TIKTOK) {
                        <div
                            class="agpr-postFeed-mainInfo-engagementWrapper"
                            [agprTooltip]="('Social.postFeed.views' | localize) + (mention?.view ?? 'N/A') + '\n' + ('Social.postFeed.lastUpdate' | localize)
                                + (mention?.engagementLastFetchedDate ? (mention?.engagementLastFetchedDate | changeTimeZone: preferences.timeZone: 'MMMM D, YYYY H:mm z') : 'N/A')"
                            tooltipPosition='top'
                        >
                            <span class="agpr-postFeed-mainInfo-engagement-icon fa-regular fa-duotone fa-duotone fa-eye"></span>
                            <span>{{ mention?.view ?? 'N/A' }}</span>
                        </div>
                    }
                    <div
                        class="agpr-postFeed-mainInfo-engagementWrapper"
                        [agprTooltip]="('Social.postFeed.likes' | localize) + (mention?.like ?? 'N/A') + '\n' + ('Social.postFeed.lastUpdate' | localize)
                            + (mention?.engagementLastFetchedDate ? (mention?.engagementLastFetchedDate | changeTimeZone: preferences.timeZone: 'MMMM D, YYYY H:mm z') : 'N/A')"
                        tooltipPosition='top'
                    >
                        <span class="agpr-postFeed-mainInfo-engagement-icon fa-regular fa-duotone fa-thumbs-up"></span>
                        <span>{{ mention?.like ?? 'N/A' }}</span>
                    </div>
                    <div
                        class="agpr-postFeed-mainInfo-engagementWrapper"
                        [agprTooltip]="('Social.postFeed.comments' | localize) + (mention?.reply ?? 'N/A') + '\n' + ('Social.postFeed.lastUpdate' | localize)
                            + (mention?.engagementLastFetchedDate ? (mention?.engagementLastFetchedDate | changeTimeZone: preferences.timeZone: 'MMMM D, YYYY H:mm z') : 'N/A')"
                        tooltipPosition='top'
                    >
                        <span class="agpr-postFeed-mainInfo-engagement-icon fa-regular fa-duotone fa-comment"></span>
                        <span>{{ mention?.reply ?? 'N/A' }}</span>
                    </div>

                    @if (mediaType === mediaTypes.FACEBOOK || mediaType === mediaTypes.TIKTOK) {
                        <div
                            class="agpr-postFeed-mainInfo-engagementWrapper"
                            [agprTooltip]="('Social.postFeed.shares' | localize) + (mention?.share ?? 'N/A') + '\n' + ('Social.postFeed.lastUpdate' | localize)
                                + (mention?.engagementLastFetchedDate ? (mention?.engagementLastFetchedDate | changeTimeZone: preferences.timeZone: 'MMMM D, YYYY H:mm z') : 'N/A')"
                            tooltipPosition='top'
                        >
                            <span class="agpr-postFeed-mainInfo-engagement-icon fa-regular fa-duotone fa-circle-nodes"></span>
                            <span>{{ mention?.share ?? 'N/A' }}</span>
                        </div>
                    }
                </div>
            }
        </div>
    </div>
    <div class="agpr-postFeed-divider"></div>
    <div class="agpr-postFeed-additionalInfo">
        <div class="agpr-postFeed-additionalInfo-topRow">
            <div class="agpr-postFeed-additionalInfo-metadata">
                @if (preferences) {
                    @let publishedTime = ('Social.postFeed.datePublished' | localize) + (mention?.datePublished | changeTimeZone: preferences.timeZone: dateFormat);
                    @let availableTime = ('Social.postFeed.dateAvailable' | localize) + (mention?.dateAvailable | changeTimeZone: preferences.timeZone: dateFormat);
                    <agpr-meta-data
                        class="agpr-postFeed-additionalInfo-metadata-item"
                        [icon]="'fa-solid fa-calendar-days'"
                        [value]="(showPublishedDate ? mention.datePublished : mention.dateAvailable) | changeTimeZone: preferences.timeZone: dateFormat"
                        [tooltip]="showPublishedDate ? '<b>' + publishedTime + '</b>\n' + availableTime : publishedTime + '\n<b>' + availableTime + '</b>'"
                        [ariaLabel]="publishedTime + ' ' + availableTime"
                    ></agpr-meta-data>
                }
                <agpr-meta-data
                    class="agpr-postFeed-additionalInfo-metadata-item"
                    [type]="attributeTypes.sentiment"
                    [icon]="'fa-solid fa-face-smile'"
                    [value]="mention.sentimentName"
                    [tooltip]="'Social.postFeed.sentiment'"
                ></agpr-meta-data>
                <agpr-meta-data
                    class="agpr-postFeed-additionalInfo-metadata-item"
                    [type]="attributeTypes.audienceReach"
                    [icon]="'fa-solid fa-user-group'"
                    [value]="mention.audienceReach"
                    [tooltip]="impressionLabel"
                ></agpr-meta-data>
            </div>

            @if (mentionInFolderBadge) {
                <div
                    class="agpr-postFeed-additionalInfo-badgeWrapper"
                >
                    <div
                        class="agpr-postFeed-additionalInfo-badge"
                    >
                        <span
                            role="img"
                            [class]="mentionInFolderBadge.icon"
                            [agprTooltip]="mentionInFolderBadge.tooltip"
                            tooltipPosition='top'
                        ></span>
                    </div>
                </div>
            }
            <div
                class="agpr-postFeed-additionalInfo-badgeWrapper"
                *ngIf="!_showImages && (mention.images?.length > 0 || embedVideoUrl)"
            >
                <div
                    class="agpr-postFeed-additionalInfo-badge"
                    *ngIf="mention.images?.length > 0"
                >
                    <span
                        role="img"
                        class="fa-regular fa-duotone fa-image"
                        agprTooltip="Social.postFeed.badge.image"
                        tooltipPosition='top'
                    ></span>
                </div>
                <div
                    class="agpr-postFeed-additionalInfo-badge"
                    *ngIf="embedVideoUrl"
                >
                    <span
                        role="img"
                        class="fa-regular fa-duotone fa-film"
                        agprTooltip="Social.postFeed.badge.video"
                        tooltipPosition='top'
                    ></span>
                </div>
            </div>
            <div
                class="agpr-postFeed-additionalInfo-badgeWrapper"
                *ngIf="mention.createdByUserId || mention.createdDate"
            >
                <div
                    class="agpr-postFeed-additionalInfo-badge"
                >
                    <span
                        role="img"
                        class="fa-regular fa-duotone fa-floppy-disk"
                        agprTooltip="Social.postFeed.badge.savedPost"
                        tooltipPosition='top'
                    ></span>
                </div>
            </div>
            <div class="agpr-expandToggle">
                <span
                    role="button"
                    class="agpr-postFeed-additionalInfo-expandToggleIcon fa-solid"
                    [ngClass]="{
                        'fa-angle-up': contentVisible,
                        'fa-angle-down': !contentVisible,
                        'agpr-postFeed-additionalInfo-expandToggleIcon--cannotExpand': !canExpand
                    }"
                    [attr.tabindex]="canExpand ? 0 : -1"
                    [attr.aria-expanded]="contentVisible"
                    [attr.aria-controls]="id + '_feedContent'"
                    (click)="toggleExpanded($event)"
                    [attr.aria-label]="'Social.postFeed.expandPost' | localize"
                    [pTooltip]="'Social.postFeed.expandPost' | localize"
                    (keydown)="onKeydown($event)"
                >
                </span>
            </div>
        </div>
    </div>
    <div
        class="agpr-contextMenu bottom right"
        [agprTooltip]="mention.translating ? ('Mention.translating' | localize) : ''"
        [agprLoading]="mention.translating"
        [loadingSmallIndicator]="mention.translating"
    >
        <agpr-button
            *ngIf="openAiPermission &&
            ((mention?.languageModel?.name | localize) !== userLanguage)"
            [id]="'quick-translate-social' + mention?.id"
            icon="fa-kit-duotone fa-agpr-translate"
            [style]="buttonTypes.contextMenu"
            [tooltip]="(concurrentTranslation >= maxConcurrentTranslation) ?
                ('Mention.translate.tooManyRequests' | localize : {
                    max : maxConcurrentTranslation
                }) :
                ('Mention.translateTo' | localize: {
                    language: mention?.showTranslated && mention?.language ? ('Language.' + mention?.language | localize) : userLanguage
                })
            "
            tooltipPosition="top"
            (click)="mention?.showTranslated ? revertTranslate() : translate()"
        >
        </agpr-button>
        <agpr-button
            [icon]="'fa-regular fa-duotone fa-eye'"
            (click)="openPostViewer()"
            [style]="buttonTypes.contextMenu"
            tooltip="Social.post.viewer.viewPostInformation"
        ></agpr-button>
    </div>
</div>
